import { render, staticRenderFns } from "./honour-chunk.vue?vue&type=template&id=054af8c4&scoped=true&"
import script from "./honour-chunk.vue?vue&type=script&lang=js&"
export * from "./honour-chunk.vue?vue&type=script&lang=js&"
import style0 from "./honour-chunk.vue?vue&type=style&index=0&id=054af8c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054af8c4",
  null
  
)

export default component.exports